// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projectAvatar[data-v-4def83c8]{\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: 133px;\n  border-radius: 2px;\n  background: url(<path-to-image>), lightgray 50% / cover no-repeat;\n  -webkit-box-shadow: 0px 0px 8px 0px rgba(113, 121, 134, 0.24);\n          box-shadow: 0px 0px 8px 0px rgba(113, 121, 134, 0.24);\n}\n", ""]);
// Exports
module.exports = exports;
